(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rvxm-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rvxm-banner')) {
  customElements.define('rvxm-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const video = this.querySelector('video');
      const button = this.querySelector('.rvxm-video-toggle');
      if (!video || !button) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        button.setAttribute('aria-pressed', String(!video.paused));
        button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('[data-play]').hidden = !video.paused;
        button.querySelector('[data-pause]').hidden = video.paused;
      };
      button.addEventListener('click', () => {
        if (video.paused) video.play().catch(update); else video.pause();
      }, { signal });
      video.addEventListener('play', update, { signal });
      video.addEventListener('pause', update, { signal });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); }, { signal });
      if (button.dataset.autoplay === 'true' && !reduced.matches && !navigator.connection?.saveData) {
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting && !this.started) { this.started = true; video.play().catch(update); }
          if (!entry.isIntersecting) video.pause();
        }, { threshold: .1 });
        this.observer.observe(this);
      }
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
if (!window.rivoxMotionEvents) {
  window.rivoxMotionEvents = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rvxm-search[open],.rvxm-mobile-menu[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('shopify:block:select', event => {
    const question = event.target.closest('.rvxm-question');
    if (question) question.open = true;
  });
}
  } catch(e) { console.error(e); }
})();

})();
